export default "__VITE_ASSET__BMcaBYwZ__"